import { getClient } from '@/lib/restClient';
import { StoreManagementAssociateBrandService } from '@/services/StoreManagement/AssociateBrands/StoreManagementAssociateBrandService';

export const useStoreManagementAssociateBrandDelete = async (
  id: string
): Promise<void> => {
  const storeManagementBrandService = new StoreManagementAssociateBrandService(
    getClient()
  );
  return await storeManagementBrandService.delete(id);
};
